export default __webpack_public_path__ + "static/media/red-x.a118e9c6.svg";